import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const Header = () => {
    const [isHidden, setIsHidden] = useState(false);
    const [visibleItems, setVisibleItems] = useState(Array(5).fill(false)); // Array to track visibility of nav items
    const lastScrollY = useRef(0); // Use useRef to keep track of the last scroll position
    const location = useLocation(); // Get current location

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > lastScrollY.current) {
                setIsHidden(true); // User is scrolling down
            } else {
                setIsHidden(false); // User is scrolling up
            }
            lastScrollY.current = window.scrollY; // Update last scroll position
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []); // Empty dependency array ensures this runs only once

    useEffect(() => {
        const timer = setTimeout(() => {
            setVisibleItems((prev) => prev.map((_, index) => index === 0 ? true : prev[index])); // Fade in first item
        }, 0);

        const secondTimer = setTimeout(() => {
            setVisibleItems((prev) => prev.map((_, index) => index === 1 ? true : prev[index])); // Fade in second item
        }, 100); // 200ms delay

        const thirdTimer = setTimeout(() => {
            setVisibleItems((prev) => prev.map((_, index) => index === 2 ? true : prev[index])); // Fade in third item
        }, 200); // Another 200ms delay

        const fourthTimer = setTimeout(() => {
            setVisibleItems((prev) => prev.map((_, index) => index === 3 ? true : prev[index])); // Fade in fourth item
        }, 300); // Another 200ms delay

        const fifthTimer = setTimeout(() => {
            setVisibleItems((prev) => prev.map((_, index) => index === 4 ? true : prev[index])); // Fade in fifth item
        }, 400); // Another 200ms delay

        return () => {
            clearTimeout(timer);
            clearTimeout(secondTimer);
            clearTimeout(thirdTimer);
            clearTimeout(fourthTimer);
            clearTimeout(fifthTimer);
        };
    }, []);

    const handleIconClick = () => {
        const aboutSection = document.getElementById('cover'); // Get the About Me section
        if (aboutSection) {
            const headerHeight = document.querySelector('header').offsetHeight; // Get header height
            const offsetPosition = aboutSection.getBoundingClientRect().top + window.scrollY - headerHeight; // Calculate offset position
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth' // Smooth scroll effect
            });
        }
    };

    const handleScrollToSection = (sectionId) => {
        const section = document.getElementById(sectionId);
        if (section) {
            const headerHeight = document.querySelector('header').offsetHeight; // Get header height
            const offsetPosition = section.getBoundingClientRect().top + window.pageYOffset - headerHeight; // Calculate offset position
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth' // Smooth scroll effect
            });
        }
    };

    // Hide header if on the archive page
    if (location.pathname === '/archive') {
        return null; // Do not render the header
    }

    return (
        <header className={`py-4 ${isHidden ? 'hide' : ''}`}>
            <div className="header-content">
                <div className="icon-container" onClick={handleIconClick} style={{ cursor: 'pointer' }}>
                    <i className="fab fa-cuttlefish fa-2x"></i> {/* Icon on the left */}
                </div>
                <nav>
                    <ul className="nav">
                        <li className="nav-item">
                            <a 
                                className={`nav-link fade-up ${visibleItems[0] ? "visible" : ""}`} 
                                onClick={() => handleScrollToSection('about')}
                            >
                                About Me
                            </a>
                        </li>
                        <li className="nav-item">
                            <a 
                                className={`nav-link fade-up ${visibleItems[1] ? "visible" : ""}`} 
                                onClick={() => handleScrollToSection('education')}
                            >
                                Education
                            </a>
                        </li>
                        <li className="nav-item">
                            <a 
                                className={`nav-link fade-up ${visibleItems[2] ? "visible" : ""}`} 
                                onClick={() => handleScrollToSection('experience')}
                            >
                                Experience
                            </a>
                        </li>
                        <li className="nav-item">
                            <a 
                                className={`nav-link fade-up ${visibleItems[3] ? "visible" : ""}`} 
                                onClick={() => handleScrollToSection('projects')}
                            >
                                Projects
                            </a>
                        </li>
                        <li className="nav-item">
                            <a 
                                className={`nav-link fade-up ${visibleItems[4] ? "visible" : ""}`} 
                                onClick={() => handleScrollToSection('contact')}
                            >
                                Contact
                            </a>
                        </li>
                    </ul>
                    <a className="resume-button" href="/resume.pdf" target="_blank" rel="noopener noreferrer">Resume</a>
                </nav>
            </div>
        </header>
    );
};

export default Header;